var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footerCommon"},[_c('van-button',_vm._b({staticClass:"submit ls1",attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('clickButton')}}},'van-button',_vm.$attrs,false),[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }